export default  {
  bindings: {
    discount: '='
  },
  controller: 'discountFormController',
  template: require('../views/discount.form.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/discounts/components/discount.form.component.js